import { IGiftCardPaymentValue } from 'features/cashier/services/types/giftCard';
import CardBox from 'features/payment/components/CardBox';
import { IStateDetailPayment } from 'features/payment/services/types/payment';
import { useEffect, useRef } from 'react';
import { useAppDispatch } from 'store/hooks';
import multiplePaymentActions from '../../../services/actions';
import multiplePaymentSelectors from '../../../services/selectors';
import CardBoxV2 from '../CardBoxV2';
import { ModalPaymentGiftCardRefs } from './ModalPaymentGiftCard';

type IGiftCardButtonProps = {
  active?: boolean;
  amountKB?: number;
  disabled?: boolean;
  onRedeem: (_detailPayment: IStateDetailPayment) => Promise<void>;
  v2?: boolean;
};

const ButtonGiftCard = ({ active = false, disabled, amountKB = 0, v2 }: IGiftCardButtonProps) => {
  const dispatch = useAppDispatch();
  const refModal = useRef<ModalPaymentGiftCardRefs>(null);
  const detail = multiplePaymentSelectors.getDetail();

  const visible = multiplePaymentSelectors.getVisibleModalGiftCard();
  const setOpen = (val: boolean) => {
    dispatch(multiplePaymentActions.setVisibleModalGiftCard(val));
  };

  useEffect(() => {
    if (!visible) return;
    refModal.current?.setAmount(amountKB || 0);
  }, [visible, detail]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleRedeem = (val: IGiftCardPaymentValue) => {
    dispatch(multiplePaymentActions.setGiftCardPayment(val));

    /**
     * AUTO COMPLETE PAYMENT
    */
    // if ((remaining - val.amount) <= 0) {
    //   onRedeem({
    //     ...detailPayment,
    //     GIFT_CARD: val,
    //   });
    // }
  };

  return (
    <>
      {v2 ? <CardBoxV2 type='GIFT_CARD' disabled={disabled} onClick={handleOpen} /> :
        <CardBox disabled={disabled} onClick={handleOpen}
          type={active ? 'ACTIVE' : 'DEFAUL'}
          icon="giftCardDefault" >
          Gift Card
        </CardBox>
      }
      {/* <ModalPaymentGiftCard
        v2={v2}
        ref={refModal}
        visible={visible}
        onClose={handleClose}
        onSubmit={handleRedeem}
        total={amountKB || 0}
      /> */}
    </>
  );
};
ButtonGiftCard.displayName = 'ButtonGiftCard';
export default ButtonGiftCard;
